import { useState, CSSProperties, useEffect  } from 'react';
import { useDropzone, DropzoneOptions } from 'react-dropzone';
import { useCart } from 'react-use-cart';
import { cloudinaryService } from 'services/Services';

interface FileWithPreview extends File {
    preview: string;
}

interface ImageUploadProps {
    onFileChange: (file: File | null) => void;
    initialImg: File | null;
}

const thumbsContainer: CSSProperties = {
    display: 'block',
    height: '60px',
    width: 'auto'
};

const dragStyle: CSSProperties = {
    margin: 0,
    color: '#0065ae'
}

const ImageUploadArea = ({ onFileChange, initialImg }:ImageUploadProps) => {
    

  
    const [error, setError] = useState<string | null>(null);
    const [files, setFiles] = useState<FileWithPreview[]>([]);
    const [isFocused, setIsFocused] = useState<boolean>(false);

useEffect(() => {
    if (initialImg !== null) {
        const previewFile = Object.assign(initialImg, {
            preview: URL.createObjectURL(initialImg)
        });
        setFiles([previewFile]); // Correctly set as an array
    }
}, []);

    const { getRootProps, getInputProps } = useDropzone({
        accept: {
          'image/*': []
        },
        maxFiles: 1,
        onDrop: (acceptedFiles: File[]) => {
            setFiles(acceptedFiles.map(file => Object.assign(file, {
                preview: URL.createObjectURL(file)
            }
        )));
            setError(null);
            
            if(acceptedFiles.length > 0) {
                onFileChange(acceptedFiles[0]);
            }
        },
        onDropRejected: () => {
            setError('Kun en logo er lov å laste opp');
        },
        onDragEnter: () => setIsFocused(true),
        onDragLeave: () => setIsFocused(false),
        onDropAccepted: () => setIsFocused(false)
    } as DropzoneOptions);

    const handleRemove = (fileName: string) => {
        setFiles(files.filter(file => file.name !== fileName));
        onFileChange(null);
      };


    const thumbs = files.map(file => (
        <div key={file.name} className="cc-logo-preview mb-3">
            <span className="cc-help cc-logo-preview__close" data-bs-toggle="tooltip" data-bs-title="Slett logo" role="button" aria-label="Slett logo" onClick={() => handleRemove(file.name)}>
                <i className="bi bi-x-circle-fill"></i> 
            </span>
            <img src={file.preview} alt="Logo" onLoad={() => { URL.revokeObjectURL(file.preview) }} />
        </div>
    ));

    useEffect(() => {
        // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
        return () => files.forEach(file => URL.revokeObjectURL(file.preview));
    }, [files]);

    return (
        <>
                {thumbs !== null && thumbs}
                <div {...getRootProps({ className: `dropzone cc-upload-logo mb-3 ${isFocused ? 'border-success' : ''}` })}>
                    <input {...getInputProps()} />
                    <p style={dragStyle}>Dra logo hit eller klikk for å velge fil</p>
                </div>
                {error && <div className="text-danger mt-2">{error}</div>}
        </>
    )
}

export default ImageUploadArea;